import { Button } from "antd";
import { UploadChangeParam } from "antd/es/upload";
import Dragger from "antd/es/upload/Dragger";
import { UploadFile } from "antd/lib";
import { useState } from "react";
import AXIOS from "../../../helpers/api";
import { BASE_API } from "../../../helpers/apiUrl";
import { toast } from "../../../helpers/toast";
import { extension } from "../../../utils/array";
import { sliceString } from "../../../utils/string";
import CustomModal from "../../common/CustomModal";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import { updateBatchPaymentAsync } from "../../../store/features/NP/supplier/supplierAPI";

type Props = {
  open: boolean;
  handleClose: () => void;
  data?: any;
  reRender: (val: boolean) => void;
  uploadedCount: (val: number, total: number) => void;
};

export default function ImportPdf({
  open,
  handleClose,
  data,
  reRender,
  uploadedCount,
}: Props) {
  const [loading, setLoading] = useState(false);
  const [fileName, setFileName] = useState("No file chosen");
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [pdfUrl, setPdfUrl] = useState("");
  const dispatch = useAppDispatch();
  const { postLoading } = useAppSelector((state) => state.supplier);

  const handleUpload = async (file: any) => {
    const formData = new FormData();
    formData.append("photo", file);
    formData.append("name", file.name);

    setLoading(true);

    try {
      const response = await AXIOS.post(`${BASE_API.fileUpload}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      // const url = response?.data?.location;
      const fileUrl = response?.data?.photo;

      // console.log(url);
      // console.log(fileUrl);
      const newValue = {
        vat: fileUrl,
      };

      dispatch(
        updateBatchPaymentAsync({
          data: newValue,
          others: {
            reRender,
            id: data?._id,
          },
        })
      );

      if (response.status === 200) {
        setFileName(`${sliceString(fileUrl, 30, "...")}.${extension(fileUrl)}`);

        setPdfUrl(fileUrl);
        setLoading(false);
      }
    } catch (error) {
      toast("error", "File upload fail");
      setLoading(false);
    }

    return false;
  };

  const handleChange = (info: UploadChangeParam<UploadFile<any>>) => {
    setFileList(info.fileList);

    if (info.file.status === "removed") {
      setPdfUrl("");
      setFileName("");
    }
  };

  return (
    <>
      <CustomModal
        width={600}
        title="PDF"
        open={open}
        handleClose={handleClose}
      >
        <div className="p-6">
          <label className="text-[#3d4a5c] text-sm font-medium leading-normal mb-1.5 inline-block">
            Import PDF File
          </label>
          <Dragger
            name="file"
            action=""
            accept=".pdf"
            maxCount={1}
            showUploadList={false}
            beforeUpload={handleUpload}
            onChange={handleChange}
            // onDrop={(e) => handleUploadFile(e.dataTransfer.files[0])}

            disabled={loading}
            className="import_excel"
            fileList={fileList}
          >
            <Button
              className="flex justify-between items-center"
              size="large"
              disabled={loading}
              style={{ width: "100%" }}
            >
              <div className="flex items-center gap-2 text-sm font-normal font-roboto text-[#8797ae]">
                <span className="text-accent font-medium text-base leading-7 relative">
                  Choose File
                </span>
                <span className="border-r border-solid border-l-0 border-y-0 border-others-border h-4" />
                {loading ? "Uploading..." : fileName}
              </div>
            </Button>
          </Dragger>

          <div className="px-4 py-[9px] bg-[#fffbe6] rounded-md border border-[#ffe58f] text-sm text-[#874d00] mt-4">
            <span className="font-medium">Warning! </span>
            <span>Upload only pdf file.</span>
            {/* <button
              className="text-[#1890ff] cursor-pointer text-sm font-medium bg-transparent border-none"
              // onClick={handleDownloadExcel}
              // disabled={excelLoading}
            >
              click here
            </button> */}
          </div>

          <div className="flex justify-center mt-7">
            <Button
              size="large"
              type="primary"
              className="w-72 !h-12"
              // onClick={handleUpload}
              // disabled={loading || userLoading || uploadedData?.length === 0}
              loading={postLoading}
            >
              Upload
            </Button>
          </div>
        </div>
      </CustomModal>
    </>
  );
}
